/**
 * Comprueba un array de objetos y devuelve uno aleatoriamente
 * en base al peso que se le haya asignado. Propiedad porcentaje
 * es necesaria, y al menos un elemento obviammente
 * @param {Array} multipleOptions array de objetos
 */
export const chooseOptionFromArray = (multipleOptions) => {
  try {
    if (multipleOptions.length === 1) {
      return multipleOptions[0];
    }
    const random = Math.random() * 100;
    let auxRandom = 0;
    let selectedOption = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < multipleOptions.length; i++) {
      if (parseInt(multipleOptions[i].porcentaje, 10) + auxRandom > random) {
        selectedOption = i;
        break;
      } else {
        // eslint-disable-next-line radix
        auxRandom += parseInt(multipleOptions[i].porcentaje);
      }
    }
    return multipleOptions[selectedOption];
  } catch (e) {
    return multipleOptions[0];
  }
};

export const convertPxToRem = (px) => {
  return px / 16;
};

export const getUrlWithoutFinalBar = (url) => {
  if (url[url.length - 1] === '/') {
    return url.slice(0, url.length - 1);
  }
  return url;
};

export const mergeConfigPage = (config, path) => {
  let result = config.default;
  const auxPath = path[0] !== '/' ? `/${path}` : path;
  if (auxPath === '/') {
    if (config[getUrlWithoutFinalBar('/kit-digital')]) {
      result = config[getUrlWithoutFinalBar('/kit-digital')];
    }
  } else if (config[getUrlWithoutFinalBar(auxPath)]) {
    result = config[getUrlWithoutFinalBar(auxPath)];
  }
  return result;
}
